var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['d-flex','flex-row',..._vm.classes]},[_c('img',{attrs:{"src":_vm.src}}),_c('strong',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.extra))])])
}
var staticRenderFns = []

export { render, staticRenderFns }